"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.once = once;
function once(fn) {
    var promise;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length) {
            throw new Error('Once cannot be called with args');
        }
        if (!promise) {
            promise = fn();
            promise.catch(function () {
                promise = undefined;
            });
        }
        return promise;
    };
}
//# sourceMappingURL=once.js.map